import useApi from '../hook/useApi';

const useSubscriptionApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getSubscriptionPlans = async (filter) => {
    return sendRequest(`/payment/subscription_plan/get_all_list`, 'GET', {});
  };

  const addSubscriptionPlan = async (payload) => {
    return sendRequest(`/payment/subscription_plan/add_subscription_plan`, 'POST', payload);
  };

  const updateSubscriptionPlan = async (payload, doLoading = true) => {
    return sendRequest(`/payment/subscription_plan/edit_subscription_plan/${payload._id}`, 'PUT', payload, doLoading);
  };

  const buyPlanWithoutMoney = async (payload) => {
    return sendRequest(`/payment/subscription_plan/buy_without_money`, 'POST', payload);
  };

  return {
    getSubscriptionPlans,
    addSubscriptionPlan,
    updateSubscriptionPlan,
    buyPlanWithoutMoney,
    loading,
    data,
    error,
  };
};

export default useSubscriptionApi;